module.exports = __webpack_public_path__ + "static/img/construction.51b6053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/construction.jpg
// module id = jkOC
// module chunks = 0